import { MenuItem, useDisclosure } from "@chakra-ui/react";
import { useMemo, useState } from "react";
import { useGlossary } from "src/hooks/useGlossary";
import { SchoolFormId } from "../types";
import { useBulkActionTargets } from "./bulkActionTargetsContext";
import { MultiSchoolWarningDialog } from "./MultiSchoolWarningDialog";
import { RunMatchFormServiceDialog } from "./RunMatchFormServiceDialog";

interface RunMatchFormServiceProps {
  selectedFormSchools: SchoolFormId[];
}

export const RunMatchFormService: React.FC<RunMatchFormServiceProps> = ({
  selectedFormSchools,
}) => {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const [matchName, setMatchName] = useState("");
  const { glossary } = useGlossary();
  const [showMultiSchoolWarning, setShowMultiSchoolWarning] = useState(false);
  const { selectionSize } = useBulkActionTargets();

  const hasMultipleSchools = useMemo(() => {
    const uniqueSchools = new Set(
      selectedFormSchools
        .map((sf) => sf.schoolId)
        .filter((id): id is string => !!id)
    );
    return uniqueSchools.size > 1;
  }, [selectedFormSchools]);

  const handleRunMatchClick = () => {
    if (hasMultipleSchools) {
      setShowMultiSchoolWarning(true);
    } else {
      onOpen();
    }
  };

  const handleConfirmMultiSchool = () => {
    setShowMultiSchoolWarning(false);
    onOpen();
  };

  return (
    <>
      <MenuItem
        textColor="gray.700"
        fontWeight="400"
        fontSize="sm"
        onClick={handleRunMatchClick}
        isDisabled={!selectionSize}
      >
        {glossary`Run match`}
      </MenuItem>

      <MultiSchoolWarningDialog
        isOpen={showMultiSchoolWarning}
        onClose={() => setShowMultiSchoolWarning(false)}
        onConfirm={handleConfirmMultiSchool}
      />

      <RunMatchFormServiceDialog
        selectionSize={selectionSize}
        isOpen={isOpen}
        onCancel={onClose}
        matchName={matchName}
        onMatchNameChange={setMatchName}
      />
    </>
  );
};
